import utils from '../utils.js';
import toFormData from './toFormData.js';
import platform from '../platform/index.js';

function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target};return _extends.apply(this,arguments)}function toURLEncodedForm(data,options){return toFormData(data,new platform.classes.URLSearchParams,_extends({visitor:function(value,key,path,helpers){if(platform.isNode&&utils.isBuffer(value)){this.append(key,value.toString("base64"));return false}return helpers.defaultVisitor.apply(this,arguments)}},options))}

export { toURLEncodedForm as default };
//# sourceMappingURL=toURLEncodedForm.js.map
